import { t } from '@repo/i18n';
import { useLocale } from '@repo/i18n/react';
import { PasswordForm } from '@/components/forms/password';
import { SettingsHeader } from '@/components/settings-header';
import { useSession } from '@/providers/session';

export const PasswordSetting = () => {
  useLocale();

  const { user } = useSession();
  return (
    <div className="raven-page raven-settings">
      <SettingsHeader
        subtitle={t('auth.hereYouCanManageYourPasswordAndSecuritySettings')}
        title={t('auth.security')}
      />
      <PasswordForm user={user} />
      <hr className="mt-6 border-border/50" />
      {/* 
      <Alert
        className="mt-6 flex flex-col justify-between p-6 sm:flex-row sm:items-center"
        variant="default"
      >
        <div className="me-4 mb-4 sm:mb-0">
          <AlertTitle>Recent activity</AlertTitle>

          <AlertDescription className="me-2">
            View all recent security activity related to your account.
          </AlertDescription>
        </div>

        <Button asChild className="bg-background" variant="outline">
          <OLink to="/settings/activity">View activity</OLink>
        </Button>
      </Alert>

      <Alert
        className="mt-6 flex flex-col justify-between p-6 sm:flex-row sm:items-center"
        variant="default"
      >
        <div className="me-4 mb-4 sm:mb-0">
          <AlertTitle>Active sessions</AlertTitle>

          <AlertDescription className="me-2">
            View and manage all active sessions for your account.
          </AlertDescription>
        </div>

        <Button asChild className="bg-background" variant="outline">
          <OLink to="/settings/sessions">Manage sessions</OLink>
        </Button>
      </Alert> */}
    </div>
  );
};
